import React from 'react'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import ProBadge from 'components/common/ProBadge'
import { startProCheckout } from '../../../proCheckout'
import { HugeiconsIcon } from '@hugeicons/react'
import {
  PaintBoardIcon
} from '@hugeicons/core-free-icons'

const allColoredByStatus = (item) => {
  if (!item.geopolygons) return !!item.status
  const shapes = [...item.geopolygons, ...(item.boundaries || []), ...(item.zipCodeBoundaries || [])]
  return shapes.length > 0 && shapes.every(shape => !!shape.status)
}

const ColorButton = ({ item, uiStore, dataStore, selectionStore, t }) => {
  const isStarter = !!(uiStore.user && uiStore.user.type === 'starter')
  const managedByStatus = dataStore.statusColorType !== 'outline' && allColoredByStatus(item)

  return (
    <button
      // Not `disabled`: disabled buttons get no hover events in some browsers, which hides the title tooltip.
      aria-disabled={managedByStatus || undefined}
      title={managedByStatus ? t('BOUNDARY.COLOR_MANAGED_BY_STATUS', { defaultValue: 'Color is managed by status' }) : undefined}
      className={`color-btn ${isStarter || managedByStatus ? 'item-controls__disabled' : ''}`}
      onClick={(e) => {
        if (managedByStatus) return
        if (isStarter) {
          startProCheckout({ uiStore, t })
          return
        }
        selectionStore.selectColorEdit(e, true)
      }}
    >
      <HugeiconsIcon icon={PaintBoardIcon} size={18} className='popup-menu__icon' />
      <span>{t('GLOBAL.COLOR')}</span>
      {isStarter && <ProBadge className='map-settings__pro text-small'>{t('GLOBAL.PRO')}</ProBadge>}
    </button>
  )
}

export default withTranslation()(inject('uiStore', 'dataStore', 'selectionStore')(observer(ColorButton)))
